import React, { forwardRef } from 'react'
import PropTypes from 'prop-types'
import { useContext } from 'sb-hooks'

import Collapsible from 'components/_new/layout/Collapsible/Collapsible'

import { AccordionItemContext } from './AccordionItem'


const AccordionPanel = forwardRef((props, ref) => {
  const { withMeasure, ...rest } = props
  const { state } = useContext(AccordionItemContext)

  return (
    <Collapsible collapsed={!state.isOpen} withMeasure={withMeasure}>
      <div
        id={state.panelId}
        aria-labelledby={state.buttonId}
        role="region"
        ref={ref}
        {...rest}
      />
    </Collapsible>
  )
})

AccordionPanel.propTypes = {
  children: PropTypes.node,
  withMeasure: PropTypes.bool,
}


export default AccordionPanel
